export default {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:8e6c4fe7-d6ee-4d81-b9d9-e14a291f80c3",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_ISjK4oXcf",
    "aws_user_pools_web_client_id": "2hmsgh5fosjp4k7en4dj24uj59",
	"oauth": {},
    "aws_appsync_graphqlEndpoint": "https://atv6bn3zbnd6veqq5l7fvq6s2y.appsync-api.us-east-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-2",
    "aws_appsync_authenticationType": "AWS_IAM"
}
